// extracted by mini-css-extract-plugin
export var cardIcon = "_87-4";
export var checkboxCard = "_87-0";
export var checkboxCardSelected = "_87-3";
export var disabled = "_87-1";
export var outerBorder = "_87-2";
export var spacerMedium = "_87-7";
export var spacerSmall = "_87-6";
export var spacerXsmall = "_87-5";